'use client';

// Catalogue public des plans d'abonnement (GET /api/subscriptions/plans).

import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api/client';
import type { Plan } from '@/types/api';

export const plansQueryKey = ['subscriptions', 'plans'] as const;

export function usePlans() {
  return useQuery({
    queryKey: plansQueryKey,
    queryFn: ({ signal }) => apiRequest<{ plans: Plan[] }>('/api/subscriptions/plans', { signal }),
    select: (data) => data.plans.slice().sort((a, b) => a.sort_order - b.sort_order),
    staleTime: 5 * 60_000, // catalogue quasi statique
  });
}
